import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/apiClient";
import SEO from "@/components/SEO";

export default function OurWork() {
  const [params, setParams] = useSearchParams();
  const [inits, setInits] = useState([]);
  const [cats, setCats] = useState([]);
  const category = params.get("category") || "";

  useEffect(() => { api.get("/categories").then(({ data }) => setCats(data)).catch(() => {}); }, []);
  useEffect(() => {
    const p = category ? `?category=${encodeURIComponent(category)}` : "";
    api.get(`/initiatives${p}`).then(({ data }) => setInits(data)).catch(() => {});
  }, [category]);

  const setCat = (v) => { const np = new URLSearchParams(); if (v) np.set("category", v); setParams(np); };

  return (
    <div className="fade-in">
      <SEO title="Our Work — NPST" description="Institutional initiatives and public-interest work across constitutional, administrative and governance domains." canonical={`${window.location.origin}/our-work`} />
      <section className="border-b border-npst-line paper-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="label-eyebrow text-npst-gold mb-3">Institutional Work</div>
          <h1 className="font-serif text-4xl sm:text-6xl font-semibold text-npst-ink tracking-tight">Our Work</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-wrap gap-2.5 mb-12 pb-6 border-b border-npst-line">
          <button onClick={() => setCat("")} className={`text-sm px-4 py-2 rounded-full border transition-colors ${!category ? "bg-npst-navy text-white border-npst-navy" : "border-npst-line text-npst-inkSoft hover:border-npst-gold"}`}>All Areas</button>
          {cats.filter((c) => !c.hidden).map((c) => (
            <button key={c.id} onClick={() => setCat(c.name)} className={`text-sm px-4 py-2 rounded-full border transition-colors ${category === c.name ? "bg-npst-navy text-white border-npst-navy" : "border-npst-line text-npst-inkSoft hover:border-npst-gold"}`}>{c.name}</button>
          ))}
        </div>
        {inits.length === 0 ? (
          <div className="py-20 text-center"><p className="font-serif text-2xl text-npst-ink">No initiatives published in this area yet</p></div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-14">
            {inits.map((it) => (
              <Link key={it.id} to={`/initiatives/${it.slug}`} className="group block" data-testid="initiative-card">
                <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.14em] text-npst-gold font-semibold mb-3">{it.category} · {it.status}</div>
                <h3 className="font-serif text-3xl text-npst-ink group-hover:text-npst-navy transition-colors leading-snug mb-3">{it.title}</h3>
                <p className="text-npst-inkSoft leading-relaxed line-clamp-3">{it.description}</p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-xs uppercase tracking-[0.12em] text-npst-navy font-semibold">Read More <ArrowRight size={13} /></span>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
